import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';
import { useAssignUserNeedValidation } from '../Product.hooks';

import {
  ProductValidation,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignValidationDialog from './AssignValidationDialog';

export type UserNeedAssignValidationDialogProps =
  BaseProductAssignDialogProps<'userNeedId'>;

const UserNeedAssignValidationDialog: React.FC<UserNeedAssignValidationDialogProps> =
  (props: UserNeedAssignValidationDialogProps) => {
    const {
      open,
      productId,
      userNeedId,
      selectedItems,
      onCancel,
      onError,
      onAssigned
    } = props;
    const {
      updatedProductUserNeed,
      isAssigning,
      error: assignError,
      assignValidations
    } = useAssignUserNeedValidation(productId, userNeedId);

    useEffect(() => {
      if (updatedProductUserNeed) {
        onAssigned?.(updatedProductUserNeed);
      }
    }, [updatedProductUserNeed]);

    useEffect(() => {
      if (assignError) {
        onError?.(assignError);
      }
    }, [assignError]);

    return (
      <AssignValidationDialog
        {...{ open, productId, selectedItems, onCancel, onError }}
        isLoading={isAssigning}
        contentText={`Search for ${getProductEntityName(
          'validation'
        )} to assign to the ${getProductEntityName('userNeed')}.`}
        onSubmit={(validations: ProductValidation[]) => {
          assignValidations({
            validationIds: validations.map(
              (validation: ProductValidation) => validation.id
            )
          });
        }}
      />
    );
  };

export default UserNeedAssignValidationDialog;
